import React, { useState } from 'react';

const services = [
  { num: '01', title: 'Campaign Architecture', desc: 'End-to-end campaign strategy built around your brand goals — from creator selection to post-launch analysis.' },
  { num: '02', title: 'Creator Matching', desc: 'Access our curated network of 500+ vetted creators aligned by niche, audience demographic, and brand affinity.' },
  { num: '03', title: 'Content Strategy', desc: 'Creative briefs and story frameworks that empower creators while keeping your brand voice precise and powerful.' },
  { num: '04', title: 'Performance Analytics', desc: 'Real-time dashboards tracking reach, engagement, conversion, and ROI so every dollar is accountable.' },
  { num: '05', title: 'Brand Partnerships', desc: 'Brokering long-term ambassador relationships that build authentic loyalty and compounding brand value.' },
  { num: '06', title: 'Growth Consulting', desc: 'Strategic advisory for brands entering influencer marketing and creators ready to scale their equity.' },
];

export default function Services() {
  const [hovered, setHovered] = useState(null);

  return (
    <section id="services" className="section-pad" style={{ padding: '120px 56px', background: 'var(--white)' }}>
      <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: '72px', flexWrap: 'wrap', gap: '24px' }}>
          <div>
            <div style={{ fontFamily: 'var(--font-body)', fontSize: '12px', fontWeight: 700, letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--accent)', marginBottom: '16px' }}>
              What We Do
            </div>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(36px, 5vw, 64px)', fontWeight: 900, lineHeight: 1, color: 'var(--ink)', textTransform: 'uppercase', letterSpacing: '-0.02em' }}>
              Services Built<br />to Make an Impact
            </h2>
          </div>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '15px', fontWeight: 400, color: 'var(--ink-muted)', maxWidth: '340px', lineHeight: 1.75 }}>
            Full-service influencer marketing from strategy to execution — everything your brand needs to grow.
          </p>
        </div>

        <div
          className="services-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            borderLeft: '1px solid var(--border)',
            borderTop: '1px solid var(--border)',
          }}
        >
          {services.map((s, i) => (
            <div
              key={i}
              style={{
                padding: '44px 40px',
                borderRight: '1px solid var(--border)',
                borderBottom: '1px solid var(--border)',
                background: hovered === i ? 'var(--off-white)' : 'var(--white)',
                transition: 'background 0.2s',
                cursor: 'default',
              }}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
            >
              <div style={{ fontFamily: 'var(--font-body)', fontSize: '12px', fontWeight: 700, letterSpacing: '0.12em', color: 'var(--accent)', marginBottom: '20px' }}>
                {s.num}
              </div>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: '22px', fontWeight: 800, color: 'var(--ink)', marginBottom: '14px', lineHeight: 1.2, textTransform: 'uppercase', letterSpacing: '-0.01em' }}>
                {s.title}
              </div>
              <div style={{ fontFamily: 'var(--font-body)', fontSize: '14px', fontWeight: 400, color: 'var(--ink-muted)', lineHeight: 1.75 }}>
                {s.desc}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
